import { type FC, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { Notification } from 'base-ui'

import { ContactPageDirectContactLabelsSection } from './ContactPageDirectContactLabelsSection'
import { ContactPageDirectContactPharmaLabelsSection } from './ContactPageDirectContactPharmaLabelsSection'

export const ContactPageDirectContactSection: FC = () => {
  const [formWasSubmittedWithSuccess, setFormWasSubmittedWithSuccess] =
    useState(false)

  return (
    <div
      className="flex w-full flex-col bg-light-primary-medium px-4 py-9 tablet:items-center tablet:py-12"
      //id is for auto-scroll redirection from Order Detail Page: https://github.com/RedTecLab/fock/pull/9765/files
      id="direct-contact-section"
    >
      <div className="tablet:max-w-4xl tablet:text-center">
        <h2 className="mb-4 text-2xl font-medium">
          <FormattedMessage id="contact.helpAndAdviceSection.title" />
        </h2>
        <p className="mb-4 text-l font-normal text-dark-primary-strong tablet:mb-10">
          <FormattedMessage id="contact.helpAndAdviceSection.description" />
        </p>
      </div>
      <div
        className="flex w-full flex-col gap-4 tablet:container tablet:flex-row tablet:justify-center tablet:gap-6"
        data-qa-id="qa-contact-page-direct-contact-links-v2"
        id="contact-page-direct-contact-links-v2"
      >
        {formWasSubmittedWithSuccess ? (
          <Notification
            className="container my-8 mt-0 w-full"
            data-qa-id="productConsultationMessageSuccess"
            severity="success"
          >
            <FormattedMessage id="product.consultation.message.success" />
          </Notification>
        ) : (
          <>
            <ContactPageDirectContactLabelsSection
              onSuccess={() => {
                setFormWasSubmittedWithSuccess(true)
              }}
            />
            <ContactPageDirectContactPharmaLabelsSection
              onSuccess={() => {
                setFormWasSubmittedWithSuccess(true)
              }}
            />
          </>
        )}
      </div>
    </div>
  )
}
